// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","962":"home"}[chunkId] + "." + {"594":"74c8bf4e","962":"1648427d"}[chunkId] + ".js";
};